export const WAITING_LIST_SHOPS = [104, 653]